export default __webpack_public_path__ + "static/media/ProdSupport-Text.923ad376.png";